// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"e48752f6","769":"9e629386"}[chunkId] + ".chunk.js";
};